import React from "react";
import { Box, Card, Container, Grid, Stack, Typography } from "@mui/material";
import Image from "../../image";
import EmailIntegration from "./EmailIntegration";
import { useResponsive } from "../../../hooks/use-responsive";

function EmailAndOtp() {
  const mdUp = useResponsive("up", "md");
  return (
    <>


      <Container maxWidth={false} sx={{
        backgroundColor: "#1D53E7",
        padding: { sm: "10px", md: "40px" },
        backgroundImage: 'url("/assets/signup_bg.svg")', // Replace with the actual image URL
        backgroundSize: "cover", // Adjust as needed
        backgroundPosition: "center", // Adjust as needed
        minHeight: !mdUp ?"105vh": null,
      }} >

        <Grid
          container
          spacing={{ xs: 6, md: 6 }}
          columns={{ xs: 6, sm: 6, md: 12 }}
        >
          {mdUp && <Grid item xs={12} md={6} lg={6}>
            <Stack direction="column" spacing={3}>
              <Typography
                variant="h3"
                sx={{
                  color: "white",
                  fontFamily: "Roboto Flex",
                  fontStyle: "italic",
                  fontWeight: 700,
                }}
              >
                Join the{" "}
                <span style={{ color: "#C7F760", fontStyle: "italic" }}>
                  {" "}
                  Revolution.{" "}
                </span>{" "}
              </Typography>
              <Typography
                sx={{
                  color: "white",
                  fontSize: 18,
                  fontFamily: "Roboto Flex",
                  fontWeight: "400",
                  wordWrap: "break-word",
                }}
              >
                Be part of a community that's transforming the way we live,
                work, and play. Sign up now and experience the future of
                technology.
              </Typography>
              <Image
                src="/assets/signup illustartion.svg"
                alt="signup_email_img"
                style={{ borderRadius: 15 }}
              />
            </Stack>
          </Grid>}
          {mdUp && <Grid item xs={12} md={6} lg={6}>
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, md: 5, lg: 5 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <EmailIntegration />
            </Card>
          </Grid>}
          {!mdUp && <Grid item xs={12} md={6} lg={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "105vh", // Full screen height
            }} >
            <Card
              sx={{
                borderRadius: 5,
                p: { xs: 3, sm: 5, lg: 5 },
                width: "100%", // Take full width in mobile view
                // maxWidth: "400px", // Set a max-width for better appearance
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // mt: 3,
                }}
              >
                <Image src="/assets/MegaconnectLOGO-06.svg" alt="logo" />
              </Box>
              <EmailIntegration />
            </Card>
          </Grid>}
        </Grid>
      </Container>
    </>
  );
}

export default EmailAndOtp;
